<template>
  <v-dialog
    v-model="visible"
    :fullscreen="mobileScreen"
    max-width="700px"
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs12>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout
          row
          wrap
        >
          <v-flex
            sm10
            xs12
            offset-sm2
            offset-xs0
          >
            <p class="sz_dark_grey--text f-16">
              {{ $t('volunteer_refuse_family.title') }}
            </p>
            <v-flex xs12>
              <SelectableList
                v-model="selectedReason"
                :items="refusalReasons"
                :multiselect="false"
              />
            </v-flex>
          </v-flex>
          <v-flex
            sm10
            xs12
            offset-sm2
            offset-xs0
          >
            <v-expand-transition>
              <v-flex
                v-if="containsOther"
                xs12
                sm10
                mt-4
              >
                <v-textarea
                  v-model="otherExplain"
                  name="input-7-1"
                  hide-details
                  auto-grow
                  :placeholder="$t('label.message')"
                  :error-messages="errors.collect('regular_field')"
                  data-vv-name="regular_field"
                />
              </v-flex>
            </v-expand-transition>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
          wrap
        >
          <v-flex
            v-if="!isRefuseValid"
            xs12
          >
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              outline
              class="mx-5 mb-3 py-2"
            >
              {{ $t('volunteer_refuse_family.no_reason') }}
            </v-alert>
          </v-flex>
          <v-flex
            order-xs2
            order-sm1
            class="lh-1 none-growth"
            :class="[mobileScreen ? 'mt-2' : 'mr-3']"
          >
            <v-btn
              flat
              class="text-none"
              color="sz_violet"
              @click="closeDialog()"
            >
              {{ $t('buttons.cancel') }}
            </v-btn>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              color="sz_violet"
              :loading="isButtonLoading"
              :disabled="isButtonLoading || emptySelectedReason"
              @click="save()"
            >
              {{ $t('buttons.send') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import filters from '@/constants/filters';
import SelectableList from '../SelectableList';

import has from 'lodash.has';

export default {
    name: 'RefuseReasonDialog',
    components: { SelectableList },
    filters: {
        ...filters
    },
    props: ['show', 'item'],
    data () {
        return {
            visible: false,
            isButtonLoading: false,
            selectedReason: { volunteer_refusal_reason: null, name: null },
            otherExplain: null,
            isRefuseValid: true
        };
    },
    computed: {
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        },
        containsOther () {
            if (this.emptySelectedReason) return false;
            return this.selectedReason.volunteer_refusal_reason === 4;
        },
        refusalReasons () {
            return this.$store.getters['defaultApi/getVolunteerRefusalReason'];
        },
        emptySelectedReason () {
            if (
                has(this.selectedReason, 'volunteer_refusal_reason') &&
        this.selectedReason.volunteer_refusal_reason === null
            ) {
                return true;
            } else if (
                !has(this.selectedReason, 'volunteer_refusal_reason') &&
        this.selectedReason === null
            ) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        show (val) {
            this.visible = val;
            if (val === false) {
                this.clear();
                this.isRefuseValid = true;
            }
        },
        visible (val) {
            this.$emit('show', val);
        }
    },
    created () {
        this.$store.dispatch('defaultApi/getVolunteerRefusalReason');
        this.visible = this.show;
    },
    methods: {
        closeDialog () {
            this.visible = false;
        },
        save () {
            this.isRefuseValid = true;
            const data = { reason: null, description: null };
            if (this.selectedReason.volunteer_refusal_reason !== null) {
                data.reason = this.selectedReason.volunteer_refusal_reason;
            }
            if (data.reason === null) {
                this.isRefuseValid = false;
            }
            if (this.containsOther) {
                if (this.otherExplain === null || this.otherExplain.length <= 0) {
                    this.isRefuseValid = false;
                } else {
                    data.description = this.otherExplain;
                }
            }
            if (this.isRefuseValid) {
                this.isButtonLoading = true;
                this.$store
                    .dispatch('volunteers/rejectFamily', { id: this.item.family_edition_id, data })
                    .then(() => {
                        this.closeDialog();
                        this.$emit('remove-item');
                    })
                    .finally(() => {
                        this.isButtonLoading = false;
                    });
            }
        },
        clear () {
            this.selectedReason = { volunteer_refusal_reason: null, name: null };
        }
    }
};
</script>

<style scoped></style>
